import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Chnage(props) {
  const symbol_id = props.symbol_id;
  const socket = useContext(SocketContext);

  const [Chnage, setChange] = useState(0);

  const [Percent, setPercent] = useState(0);

  const [LTP, setLTP] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, []);

  const trade = (data) => {
    if (data != null) {
      if (LTP !== data.LTP) {
        setLTP(data.LTP);
        setChange(data.LTP - data.Previous_Close);
        setPercent(
          ((data.LTP - data.Previous_Close) / data.Previous_Close) * 100
        );
      }
    }
  };

  return (
    <div className="Chnage">
      {" " + parseFloat(Chnage).toFixed(2)}{" "}
      {"(" + parseFloat(Percent).toFixed(2) + "%)"}
    </div>
  );
}
